import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../pages/shared/Footer/Footer';
import Navbar from '../pages/shared/Navbar/Navbar';
import Newsletter from '../pages/shared/Newsletter/Newsletter';

const Main = () => {
    return (
        <div>
            <Navbar/>
            <Outlet/>
            <Newsletter/>
            <Footer/>
        </div>
    );
};

export default Main;